module.exports = __webpack_public_path__ + "img/logo.6594b822.png";